<template>
  <div>
    <main-layout>
      <div class="tabContainer">
        <div id="vizContainer" ref="vizContainer" v-bind:style="{'height': this.reportHeight+'px','min-height':this.reportMinHeight+'px'}">
          <iframe src="" ref="edit_iframe" style="padding: 0px; border: none; margin: 0px; height: 800px; width: 100%;"></iframe>
        </div>
        <div ref="loginContainer" style="padding: 0px; border: none; margin: 0px; width: 0px; height: 0px"></div>
      </div>
    </main-layout>
  </div>
</template>
<style scoped>
  .tabContainer {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
</style>
<script>
import MainLayout from "../components/MainLayout.vue";
import config from "../../config";
import tableau from "tableau-api";
import * as api from "../api";

export default {
  data() {
    return {
      reportHeight: 785,
      reportMinHeight: 785
    };
  },
  created: function() {
    document.body.scrollTop = 0;
  },
  methods: {
    refresh_iframe: function(path) {
      let url =
        config.get("TableauServer") + "/en/embed_wrapper.html?src=" + path;
      this.$refs.edit_iframe.src = url;
    },
    exitEditHandler: function(event) {
      let new_url = event.detail.new_url.split("#")[1];
      new_url = new_url.substring(1, new_url.length);
      this.$store.commit("loading", 1);
      api.getAuth().then(response => {
        this.$store.commit("loading", -1);
        this.$store.commit("load", response.body);
      });
      this.$router.push("/");
    }
  },
  mounted: function() {
    let _self = this;
    let domain = window.location.host;
    document.domain = domain.substring(domain.indexOf('.')+1, domain.length);
    document.addEventListener("ExitEditEvent", this.exitEditHandler, false);
    let path = this.$store.state.route.query.path;
    if (this.$store.state.accessToken !== "") {
      if (this.$store.state.isTableauLogin) {
        _self.refresh_iframe(path);
      } else {
        _self.$store.commit("loading", 1);
        api.getViz(path).then(
          response => {
            let trustedUrl =
              config.get("TableauServer") + response.body.TrustedUrl;
            var options = {
              usePublishedSize: true,
              toolbarPosition: "top",
              hideToolbar: false
            };
            let viz = new tableau.Viz(
              this.$refs.loginContainer,
              trustedUrl,
              options
            );
            viz.addEventListener("customviewload", function() {
              _self.$store.commit("tableau_login");
              _self.$store.commit("loading", -1);
              _self.refresh_iframe(path);
            });
          },
          response => {
            console.log(response);
          }
        );
      }
    }
  },
  beforeDestroy: function() {
    document.removeEventListener("ExitEditEvent", this.exitEditHandler, false);
  },
  components: {
    MainLayout
  }
};
</script>


// WEBPACK FOOTER //
// TableauEdit.vue?58234f98